var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "svg",
        {
          staticClass: "c-spinner",
          attrs: { width: _vm.width, height: _vm.width, viewBox: _vm.viewBox }
        },
        [
          _c("g", { attrs: { transform: _vm.transform } }, [
            _c("circle", {
              staticClass: "c-spinner-circle",
              class: _vm.uniqClass,
              attrs: {
                "stroke-width": _vm.strokeWidth,
                x: _vm.pos,
                y: _vm.pos,
                r: _vm.radius
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _vm._t("message")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-130b63fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130b63fc","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CSpinner.vue
// module id = 2222
// module chunks = 1610